var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-container"},[_c('HeroSection'),_vm._v(" "),_c('PagsmileCard'),_vm._v(" "),_c('HowItWorks'),_vm._v(" "),_c('UseCases'),_vm._v(" "),_c('StartNow')],1)}
var staticRenderFns = []

export { render, staticRenderFns }